import React, {useEffect} from 'react';
import './App.css';
import {Outlet, Routes, Route, useLocation, NavLink} from "react-router-dom";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import {HashLink, NavHashLink} from "react-router-hash-link";
import how from "./assets/images/how.svg";
import downArrow from "./assets/images/down-arrow.svg";
import feature from "./assets/images/features.svg";
import interactive from "./assets/images/interactive-black.svg";
import integrations from "./assets/images/integrations.svg";
import file from "./assets/images/file.svg";
import marketing from "./assets/images/marketing-speaker.svg";
import sales from "./assets/images/sales.svg";
import customer from "./assets/images/customer.svg";
import support from "./assets/images/support.svg";
import training from "./assets/images/training.svg";
import product from "./assets/images/product.svg";
import salesEnabled from "./assets/images/sales-enabled.svg";
import onBoard from "./assets/images/customers.svg";
import drive from "./assets/images/drive.svg";
import knowledge from "./assets/images/knowledge.svg";


function App() {
   const { pathname } = useLocation();
   useEffect(() => {
      // "document.documentElement.scrollTo" is the magic for React Router Dom v6
      document.documentElement.scrollTo({
         top: 0,
         left: 0,
         behavior: 'auto'
      });
   }, [pathname]);



   return (
       <div className="app">
          <div className="header-sec">
             <Header />
          </div>

          <div className="app-wrapper">
             <Outlet/>
          </div>

          <div className="footer-sec">
             <Footer />
          </div>


          <div className="headerNav">
             <div className="contentSec">
                <ul className="nav-bar headerNavList">
                      <li className="nav">
                         <NavLink to={'/home'} className="nav-link rubik-medium">
                            <div className="">Platform</div>
                         </NavLink>
                         <div className="sub-nav">
                            <div className="">
                               <div className="sub-nav-content">
                                  <ul className="links">
                                     <li>
                                        <HashLink className={''} to={'/home/#how-it-works'}
                                                     scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                           <div className="icon">
                                              <img src={how} alt=""/>
                                           </div>
                                           <div className="">How it works</div>
                                        </HashLink>
                                     </li>
                                     <li>
                                        <HashLink className={''} to={'/home/#features'}
                                                     scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                           <div className="icon">
                                              <img src={feature} alt=""/>
                                           </div>
                                           <div className="">Features</div>
                                        </HashLink>
                                     </li>
                                     <li>
                                        <HashLink className={''} to={'/home/#interactive-videos'}
                                                     scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                           <div className="icon">
                                              <img src={interactive} alt=""/>
                                           </div>
                                           <div className="">Interactive videos</div>
                                        </HashLink>
                                     </li>
                                     <li>
                                        <HashLink className={''} to={'/home/#integrations'}
                                                     scroll={(el) => el.scrollIntoView({ behavior: 'smooth'})}>
                                           <div className="icon">
                                              <img src={integrations} alt=""/>
                                           </div>
                                           <div className="">Integrations</div>
                                        </HashLink>
                                     </li>
                                  </ul>
                               </div>
                               <div className="sub-nav-content">
                                  <div className="sub-nav-heading">What’s coming soon</div>
                                  <ul className="links coming-up">
                                     <li className={'flex'}>
                                        <div className="icon">
                                           <img src={file} alt=""/>
                                        </div>
                                        <div className="">How it works</div>
                                     </li>
                                     <li className={'light-color'}>
                                        Customised demo
                                     </li>
                                     <li className={'light-color'}>
                                        Self Guided Tour
                                     </li>
                                  </ul>
                               </div>
                            </div>
                         </div>
                      </li>
                      <li className="nav">
                         <NavLink to={'/useCase'} className="nav-link rubik-medium">
                            <div className="">Solutions</div>
                         </NavLink>
                         <div className="sub-nav">
                            <div className="">
                               <div className="sub-nav-content">
                                  <div className="sub-nav-heading">BY ROLE</div>
                                  <ul className="links">
                                     <li>
                                        <NavLink to={'/useCase'}>
                                           <div className="icon">
                                              <img src={marketing} alt=""/>
                                           </div>
                                           <div className="">Marketing</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={'/sales'}>
                                           <div className="icon">
                                              <img src={sales} alt=""/>
                                           </div>
                                           <div className="">Sales</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={'/customer-success'}>
                                           <div className="icon">
                                              <img src={customer} alt=""/>
                                           </div>
                                           <div className="">Customer success</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={'/support'}>
                                           <div className="icon">
                                              <img src={support} alt=""/>
                                           </div>
                                           <div className="">Support</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={'/training'}>
                                           <div className="icon">
                                              <img src={training} alt=""/>
                                           </div>
                                           <div className="">Training</div>
                                        </NavLink>
                                     </li>
                                  </ul>
                               </div>
                               <div className="sub-nav-content">
                                  <div className="sub-nav-heading">By Use cases</div>
                                  <ul className="links">
                                     <li>
                                        <NavLink className={''} to={''}>
                                           <div className="icon">
                                              <img src={product} alt=""/>
                                           </div>
                                           <div className="">Product walkthroughs</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={''}>
                                           <div className="icon">
                                              <img src={salesEnabled} alt=""/>
                                           </div>
                                           <div className="">Sales enablement</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={''}>
                                           <div className="icon">
                                              <img src={onBoard} alt=""/>
                                           </div>
                                           <div className="">Onboard customers</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={''}>
                                           <div className="icon">
                                              <img src={drive} alt=""/>
                                           </div>
                                           <div className="">Drive product adoption</div>
                                        </NavLink>
                                     </li>
                                     <li>
                                        <NavLink className={''} to={''}>
                                           <div className="icon">
                                              <img src={knowledge} alt=""/>
                                           </div>
                                           <div className="">Update knowledge base</div>
                                        </NavLink>
                                     </li>
                                  </ul>
                               </div>
                            </div>
                         </div>
                      </li>
                      <li className="nav"><NavLink className={'nav-link rubik-medium'} to="/pricing">Pricing</NavLink></li>
                      <li className="nav"><NavLink className={'nav-link rubik-medium'} to={'/blogs'}>Blog</NavLink></li>
                      <li className="highlight-color rubik-medium margin-t-10">Get Early Access</li>

                </ul>
             </div>
          </div>
       </div>
   )
}

export default App;
